import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=4524c63a&"
import script from "./WhatsApp.vue?vue&type=script&lang=js&"
export * from "./WhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports